/* eslint-disable no-irregular-whitespace */
import { ANTIVIRUS_BRAND } from 'reactApp/appHelpers/featuresHelpers/features/antivirusBrand';

export const verifiedFileByAntivirusDesktopText = `Файл проверен антивирусом${
    ANTIVIRUS_BRAND === 'default' ? '' : ` ${ANTIVIRUS_BRAND}`
} и безопасен для вашего компьютера`;

export enum EButtonLocation {
    header = 'header',
    headerMenuDots = 'header_menu_dots',
    fileMenuDots = 'file_menu_dots',
    headerRight = 'header_right',
    bottomMultiselect = 'bottom_multiselect',
    ctaButton = 'cta_button',
}
